module.exports = __webpack_public_path__ + "img/bg-mobile.409bf45c.png";